import axios from "axios";
import Config from "../../config/";
import moment from "moment";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;

export function cekAuth() {
  return {
    headers: {
      Authorization: API_KEY + localStorage.getItem("token")
    }
  };
}

export function deleteAlert(id) {
  const url = `${ROOT_URL}alert/alert/${id}/`;

  const request = axios.delete(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function updateAlert(body) {
  const url = `${ROOT_URL}alert/alert/${body.id}/`;

  const fdata = new FormData();
  fdata.append("description", body.description);
  fdata.append("userlevel", body.userlevel);
  fdata.append("company_code", body.company_code);
  fdata.append("date", body.dateAlert);
  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function pushAlert(body) {
  const url = `${ROOT_URL}alert/alert/`;

  const fdata = new FormData();
  fdata.append("company_code", body.company_code);
  fdata.append("title", body.title);
  fdata.append("description", body.description);
  fdata.append("userlevel", body.userlevel);
  fdata.append("date", body.dateAlert);
  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function fetchAlert() {
  let today = moment().format("YYYY-MM-DD");
  const url = `${ROOT_URL}alert/alert/?search=${today}`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchAlertAll() {
  const url = `${ROOT_URL}alert/alert/`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchAlertToday(date) {
  const url = `${ROOT_URL}alert/alert/?search=${date}`;
  const request = axios.get(url, cekAuth());
  return request;
}